import { CanActivate, Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(): boolean {
    const authenticated = this.authService.getSession();
    if (authenticated) {
      this.authService.me();
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
